import { render, staticRenderFns } from "./ResponsesView.vue?vue&type=template&id=088fbe73&scoped=true&"
import script from "./ResponsesView.vue?vue&type=script&lang=js&"
export * from "./ResponsesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088fbe73",
  null
  
)

export default component.exports